// hooks/useCreateNewReservation.ts
import { useDispatch } from 'react-redux';
// import {
//   setLoader
// } from "../slice/bookingCreation/bookingCreationSlice";
import { apartmentBookingApiSlice } from '../api/apartment/apartmentApiSlice';
import { store } from '../store/store';
import Logger from '../common/logger';
import { setApartments } from '../store/slices/bookingCreationSlice';
import { Dayjs } from 'dayjs';


const fetchApartmentsByCityCall = async (
    city: string,
    fromDate: string,
    toDate: string,
    numberOfGuests: number,
    orderId?: string | null,
    useCase?: string,
) => {
    const data = await store.dispatch(
        apartmentBookingApiSlice.endpoints.getApartmentByCityList.initiate({
            city: city,
            fromDate: fromDate,
            toDate: toDate,
            numberOfGuests: numberOfGuests,
            orderId: orderId,
            useCase: useCase,
        }),
    );
    return data;
};


export const useFetchApartments = (
    checkInDate: Dayjs | null,
    checkOutDate: Dayjs | null,
    city: string | null,
    numberOfGuests: number,
    orderId?: string | null,
    useCase?: string,
) => {
    const dispatch = useDispatch();
    if (!checkInDate || !checkOutDate || !city) return;

    const fetchApartments = async ({includeCurrentApartment = true}: {includeCurrentApartment?: boolean}) => {
        try {
            //   dispatch(setLoader(true));
            let apartments;

            const data = await fetchApartmentsByCityCall(
                city!, // Todo: refactor to not use !
                checkInDate?.format()!, // Todo: refactor to not use !
                checkOutDate?.format()!, // Todo: refactor to not use !
                numberOfGuests,
                includeCurrentApartment ? orderId : null,
                useCase,
            );

            if (data) {
                apartments = data.data;
            }
            if (apartments) {
                dispatch(setApartments(apartments));
            }
            // eslint-disable-next-line no-console
            return apartments;
        } catch (error) {
            Logger('fetchApartments').error(error);
        }
    };

    return fetchApartments;
};
